import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h6","key":"svg-2"}],["path",{"d":"M19 16v3m0 3v.01","key":"svg-3"}]]

const IconFilter2Exclamation = createReactComponent('outline', 'filter-2-exclamation', 'Filter2Exclamation', __iconNode);

export default IconFilter2Exclamation;